import React, { PropsWithChildren } from 'react'
import { Text } from '../../bases/Text'
import { CardSize } from './CardFrame'

const subTitleSize = {
  S: { fontSize: 10 },
  M: { fontSize: 12 },
  L: { fontSize: 14 },
}

export const NFTSubTitleText: React.FC<PropsWithChildren<{ cardSize: CardSize; text: string }>> = ({
  cardSize,
  text,
}) => {
  return (
    <Text className="flex-1 text-left text-neutral-500" style={{ ...subTitleSize[cardSize] }}>
      {text}
    </Text>
  )
}
